import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const navItems = [
  { to: '/',         label: 'Dashboard',   icon: '◈' },
  { to: '/clients',  label: 'Clients',     icon: '◇' },
  { to: '/run',      label: 'Run Report',  icon: '▷' },
  { to: '/reports',  label: 'Reports',     icon: '◻' },
  { to: '/settings', label: 'Settings',    icon: '⊙' },
];

export default function Layout() {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    navigate('/login');
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--off-white)' }}>

      {/* Sidebar */}
      <aside style={{
        width: 'var(--sidebar-width)',
        minHeight: '100vh',
        background: 'var(--charcoal)',
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        zIndex: 100,
      }}>
        {/* Logo */}
        <div style={{
          padding: '2rem 1.5rem 1.5rem',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
        }}>
          <div style={{
            fontFamily: 'var(--font-heading)',
            fontSize: '1.15rem',
            fontWeight: 600,
            color: 'var(--blush)',
            letterSpacing: '0.01em',
            lineHeight: 1.3,
          }}>
            SEO & GEO
          </div>
          <div style={{
            fontFamily: 'var(--font-body)',
            fontSize: '0.65rem',
            fontWeight: 400,
            color: 'rgba(255,255,255,0.35)',
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            marginTop: '0.2rem',
          }}>
            Intelligence Hub
          </div>
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: '1.25rem 0.75rem' }}>
          {navItems.map(({ to, label, icon }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              style={({ isActive }) => ({
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                padding: '0.6rem 0.85rem',
                borderRadius: 'var(--radius-sm)',
                marginBottom: '0.2rem',
                fontFamily: 'var(--font-body)',
                fontSize: '0.875rem',
                fontWeight: isActive ? 500 : 400,
                color: isActive ? 'var(--blush)' : 'rgba(255,255,255,0.55)',
                background: isActive ? 'rgba(242,168,184,0.12)' : 'transparent',
                textDecoration: 'none',
                transition: 'all 0.15s ease',
                letterSpacing: '0.02em',
              })}
            >
              <span style={{ fontSize: '0.9rem', opacity: 0.85 }}>{icon}</span>
              {label}
            </NavLink>
          ))}
        </nav>

        {/* Footer */}
        <div style={{
          padding: '1rem 1.5rem 1.5rem',
          borderTop: '1px solid rgba(255,255,255,0.08)',
        }}>
          <div style={{
            fontFamily: 'var(--font-body)',
            fontSize: '0.7rem',
            color: 'rgba(255,255,255,0.2)',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            marginBottom: '0.85rem',
          }}>
            Pivot & Prosper
          </div>
          <button
            onClick={handleSignOut}
            style={{
              width: '100%',
              fontFamily: 'var(--font-body)',
              fontSize: '0.78rem',
              fontWeight: 400,
              color: 'rgba(255,255,255,0.4)',
              background: 'transparent',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: 'var(--radius-sm)',
              padding: '0.45rem 0.75rem',
              cursor: 'pointer',
              textAlign: 'left',
              letterSpacing: '0.03em',
              transition: 'all 0.15s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.color = 'rgba(255,255,255,0.75)';
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.25)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.color = 'rgba(255,255,255,0.4)';
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
            }}
          >
            <span style={{ fontSize: '0.8rem' }}>→</span> Sign Out
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main style={{
        marginLeft: 'var(--sidebar-width)',
        flex: 1,
        padding: '2.5rem 2.75rem',
        maxWidth: '1100px',
      }}>
        <Outlet />
      </main>
    </div>
  );
}
